import Chip from '@mui/material/Chip';
import { CheckResult, Outcome, outcomeColor, OUTCOMES, STATUS_COLORS, STATUS_LABELS, VisitStatus } from '../siteVisits.api';

export function VisitStatusChip({ status }: { status: VisitStatus }) {
  return <Chip size='small' color={STATUS_COLORS[status] ?? 'default'} label={STATUS_LABELS[status] ?? status} />;
}

export function OutcomeChip({ outcome, label }: { outcome: Outcome | null; label?: string | null }) {
  if (!outcome) return null;
  return (
    <Chip size='small' variant='outlined' color={outcomeColor(outcome)}
      label={label || OUTCOMES.find((o) => o.code === outcome)?.label || outcome} />
  );
}

const RESULT: Record<CheckResult, { label: string; color: 'success' | 'error' | 'default' }> = {
  OK: { label: 'OK', color: 'success' },
  ISSUE: { label: 'Issue', color: 'error' },
  NA: { label: 'N/A', color: 'default' },
};

export function ResultChip({ result }: { result: CheckResult | null }) {
  if (!result) return <Chip size='small' variant='outlined' label='Pending' />;
  return <Chip size='small' color={RESULT[result].color} label={RESULT[result].label} />;
}
